<template>
  <b-row  style="padding-left: 1px"  class="no-gutters px-0 pb-0  hdr-pb">
    <slot>
    </slot>
  </b-row>
</template>

<script>

  export default {
    name: "HeaderRow",
  }
</script>

<style scoped>

</style>